// extracted by mini-css-extract-plugin
module.exports = {"body":"BAWorkAnswerList_body__3J2xS","tabs":"BAWorkAnswerList_tabs__1fRAC"};